<div [ngClass]="isLoginPage ? 'login-container' : 'app-component'">
  <app-notification-popup #notification style=" height: auto; z-index: 100;"></app-notification-popup>
  <app-navigation-bar *ngIf="showNavbar" class="navigation-component" [showNavbar]="showNavbar"></app-navigation-bar>
  <router-outlet style="display: none;"></router-outlet>
  <div *ngIf="loadingService.isLoading | async" class="spinner-overlay">
    <span class="loader"></span>
  </div>
</div>
